import AnimateOnScroll from './AnimateOnScroll';
const steps = [
  {
    badge: 'Onboarding',
    icon: 'ri-user-settings-line',
    num: '01',
    title: 'Sign Up & Brand Your Platform',
    desc: "Create your account in minutes. Upload your firm's logo and colours to deliver a fully branded AI planning experience that reflects your professional identity.",
  },
  {
    badge: 'Setup',
    icon: 'ri-settings-3-line',
    num: '02',
    title: 'Configure Your Propositions',
    desc: "Upload your investment propositions and planner-validated recommendations. The CFP-grade engine integrates your approach so every plan is accurate, auditable, and on-brand.",
  },
  {
    badge: 'Go Live',
    icon: 'ri-rocket-line',
    num: '03',
    title: 'Invite Clients & Go Live',
    desc: "Share a branded link with your clients. They explore their financial future via conversational AI while you focus on the high-value advisory work that only you can provide.",
  },
];

export default function HowItWorksSection() {
  const scrollToRegister = () => {
    const el = document.querySelector('#register');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="how-it-works" className="bg-white py-24">
      <div className="max-w-6xl mx-auto px-6">
        <AnimateOnScroll variant="fade-up">
          <div className="text-center mb-16">
            <p className="text-xs font-bold tracking-widest text-brown-300 uppercase mb-4">How It Works</p>
            <h2 className="text-4xl lg:text-5xl font-bold text-[#1a1a2e] mb-5">Up and Running in Three Simple Steps</h2>
            <p className="text-base text-[#6a6a7a] max-w-xl mx-auto leading-relaxed">
              From sign-up to your first client session — deployed faster than any traditional planning tool.
            </p>
          </div>
        </AnimateOnScroll>

        <div className="relative grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="hidden lg:block absolute top-[140px] left-[calc(16.66%+24px)] right-[calc(16.66%+24px)] h-px border-t-2 border-dashed border-[#f3f3f3] z-0"></div>

          {steps.map((step, idx) => (
            <AnimateOnScroll key={step.num} variant="fade-up" delay={idx * 150}>
              <div className="relative flex flex-col rounded-2xl border border-[#EDE8DF] bg-white p-6 sm:p-8 h-full transition-all duration-300 hover:border-[#C0B8B0] shadow-lg">
                <div className="flex items-start justify-between mb-5">
                  <div className="w-12 h-12 flex items-center justify-center bg-brown-300 rounded-xl">
                    <i className={`${step.icon} text-xl text-brown-100`}></i>
                  </div>
                  <span className="text-5xl font-light text-brown-100/40 leading-none select-none">{step.num}</span>
                </div>
                <div className="mb-4">
                  <span className="text-xs font-bold tracking-widest uppercase text-brown-200">{step.badge}</span>
                </div>
                <h3 className="text-lg font-bold text-[#1a1a2e] mb-3">{step.title}</h3>
                <p className="text-md text-[#6a6a7a] leading-relaxed flex-1">{step.desc}</p>
                <div className="flex items-center gap-1.5 mt-5">
                  {[0, 1, 2].map((i) => (
                    <div key={i} className={`h-1 rounded transition-all ${i === idx ? 'w-6 bg-brown-100' : 'w-3 bg-brown-300'}`}></div>
                  ))}
                </div>
              </div>
            </AnimateOnScroll>
          ))}
        </div>

        <AnimateOnScroll variant="fade-up" delay={100}>
          <div className="mt-14 flex flex-col items-center gap-4 text-center">
            <p className="text-md text-[#6a6a7a]">Ready to transform how your firm plans for clients?</p>
            <button
              onClick={scrollToRegister}
              className="inline-flex items-center gap-2 bg-brown-500 text-white text-md font-semibold px-8 py-3 rounded-full hover:bg-[#000000] transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-rocket-line"></i>Get Started
            </button>
          </div>
        </AnimateOnScroll>
      </div>
    </section>
  );
}
